import script from "./trial2paid.vue?vue&type=script&lang=jsx"
export * from "./trial2paid.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__